import { render, staticRenderFns } from "./AdminDistrictManagement.vue?vue&type=template&id=71d74683"
import script from "./AdminDistrictManagement.vue?vue&type=script&lang=js"
export * from "./AdminDistrictManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports